import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, BehaviorSubject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { UserSandbox } from '../../user/user.sandbox';
import { finalize } from 'rxjs/operators';
import { AWSService } from '../services/aws.service';

@Injectable({
  providedIn: 'root'
})
export class TimelapsePollingService {

  constructor(private awsService: AWSService, private snackBar: MatSnackBar) {}

  generateVideoWithNotification(params: any): Observable<any> {
    console.log('Generating video with params:', params);
    // Call generateVideoTimelapse and use finalize so the notification runs when it completes
    return this.awsService.generateTimelapseVideo(params).pipe(
      finalize(() => {
        // Here the observable has completed, even if the dialog was closed
        if (params.operation !== 'count') {
          this.snackBar.open(
            `Timelapse generated! You can find ${params.videoName} in your MyFiles section.`,
            'OK',
            { duration: 5000 }
          );
        }
      })
    );
  }
}